import LandingPageCTA from './index';

const LandingPageCTABlock = {
  Component: LandingPageCTA,
  BlockRenderer: () => <LandingPageCTA />,
  metadata: {
    name: 'rentals/landing-page-cta',
    title: 'Rentals Landing Page CTA',
    description: '',
    icon: 'businessperson',
    keywords: ['cta', 'rentals'],
    supports: {
      customClassName: false,
      html: false,
    },
    category: 'more',
    attributes: {
      size: {
        type: 'string',
        default: 'md',
        label: 'Button size',
        control: 'select',
        choices: [
          { value: 'sm', label: 'Small' },
          { value: 'md', label: 'Medium' },
          { value: 'lg', label: 'Large' },
        ],
      },
      videoCtaLabel: {
        type: 'string',
        default: '',
        label: 'Video button label',
        control: 'text',
      },
      videoUrl: {
        type: 'string',
        default: '',
        label: 'Video embed URL',
        control: 'text',
      },
    },
  },
};

export default LandingPageCTABlock;
